import * as React from "react";
import { Icon } from "./Icon";

export class AboutIcon extends Icon {

	render() {
		return <Icon {...this.props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
				<path d="M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0L16,0z" />
				<circle cx="16" cy="10" r="2" />
				<path d="M16,24L16,24c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2v6C18,23.1,17.1,24,16,24z" />
			</svg>
		</Icon>;
	}
}
